import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class UploadTestCenterUsersService {

  constructor(private backendService: BackendService) { }

  private path = '/test-center-users';

  saveUploadedTestCenterUsers(uploadtestcenterdata) {
    return this.backendService.post(this.path + '/import', uploadtestcenterdata);
  }


  searchTestCenterUserList(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);

  }

  getTestCenterUserById(centerId) {
    return this.backendService.get(this.path + "/user/" + centerId);
  }

  saveTestCenterUser(data) {
    return this.backendService.post(this.path , data);
  }

  deleteTestCenterUserById(centerId){
    return this.backendService.post(this.path + '/delete/' + centerId, {});
  }

  deleteAll(testCenterUser) {
    return this.backendService.post(this.path + "/delete", testCenterUser);
  }

  resetPassword(data){
    return this.backendService.post(this.path + "/resetpass" , data);
  }

  getPassword(data){
    return this.backendService.post(this.path + "/getpassword" , data);
  }

  

  resetAllPassword(data){
    return this.backendService.post(this.path + "/resetallpass" , data);
  }


}